class UFilteredListSelectedFilters extends Uneet {
  constructor (domElement, onClearAllClick) {
    super(domElement)
    this.__onClearAllClick = onClearAllClick
    this.activeFilterBtns = []
    this.__init()
  }

  __init () {
    this._e.querySelectorAll('button.clear-all')[0].onClick((ev) => {
      this.onClearAllClick()
    })
  }

  onClearAllClick () {
    this.__onClearAllClick()
  }

  updateCount (newCount) {
    const str = (newCount > 1) ? ' Events' : ' Event'
    this._e.querySelectorAll('span.count')[0].innerHTML = newCount + str
  }

  updateSelectedFilters (arrayOfFiltersForSelectedFilters) {
    this.__log(arrayOfFiltersForSelectedFilters)
    arrayOfFiltersForSelectedFilters.forEach((filter) => {
      const btn = this.__getActiveFilterBtn(filter.token, filter.id)
      if (filter.isActive) {
        // if active then if it doesn't exist add it
        this.__log('Filter Item!: ', filter.token, filter.id, filter.isActive)
        if (btn === null) {
          this.__addFilterBtn(filter.token, filter.id, filter.label, filter.turnOffFunction)
        }
      } else {
        // if the filter is inactive, remove if it exists
        this.__log('Filter Item?: ', filter.token, filter.id, filter.isActive)
        if (btn !== null) {
          this.__removeFilterBtn(filter.token, filter.id)
        }
      }
    })
  }

  __getActiveFilterBtn (token, id) {
    let theBtn = null
    this.activeFilterBtns.forEach((btn) => {
      const btnId = btn.getAttribute('data-id')
      const btnToken = btn.getAttribute('data-token')
      if ((btnId === id.toString()) && (btnToken === token.toString())) {
        theBtn = btn
      }
    })
    return theBtn
  }

  __removeFilterBtn (token, id) {
    let theBtn = null
    let thePos = null
    for (let i = 0; i < this.activeFilterBtns.length; i++) {
      const btn = this.activeFilterBtns[i]
      const btnId = btn.getAttribute('data-id')
      const btnToken = btn.getAttribute('data-token')
      if ((btnId === id.toString()) && (btnToken === token)) {
        theBtn = btn
        thePos = i
      }
    }
    if ((thePos !== null) && (theBtn !== null)) {
      this.activeFilterBtns.splice(thePos, 1)
      theBtn.parentNode.removeChild(theBtn)
    }
  }

  __addFilterBtn (token, id, label, onClick) {
    // construct the button
    let newFilter = document.createElement('button')
    newFilter.addClass('filter')
    newFilter.setAttribute('data-id', id)
    newFilter.setAttribute('data-token', token)
    newFilter.innerHTML = label
    newFilter.onClick((ev) => {
      onClick()
    })
    // add to internal List
    this.activeFilterBtns.push(newFilter)
    // append
    this._e.querySelectorAll('.selected-filters')[0].appendChild(newFilter)
  }

  __removeAll () {
    this._e.querySelectorAll('.selected-filters button').forEach((btn) => {
      btn.parentNode.removeChild(btn)
    })
    this.activeFilterBtns = []
  }
}
/*
class UFilteredListSelectedFilters extends Uneet {
  constructor (domElement, addFilterCallback = null, removeFilterCallback = null, clearAllFiltersCallback = null, dateFilterCallback = null) {
    super(domElement)
    this.selectedFilters = []
    this.dateFilterValue = null
    this.__dateFilterCallback = dateFilterCallback
    this.__addFilterCallback = addFilterCallback
    this.__removeFilterCallback = removeFilterCallback
    this.__clearAllFiltersCallback = clearAllFiltersCallback
    this.__idPrefix = 'selectedFilter-'
    this.__init()
  }

  __init () {
    // bind the clear all
    this._e.querySelectorAll('button.clear-all')[0].onClick((ev) => {
      this.removeAllFilters()
    })
  }

  // *********************
  // date filter processing:
  // *********************

  changeDateFilter (dateFilter) {
    // first, remove from DOM any found thing
    this.dateFilterValue = null
    const oldDateFilterDOM = this._e.querySelectorAll('button.filter.date-filter')[0]
    if (oldDateFilterDOM) {
      oldDateFilterDOM.parentNode.removeChild(oldDateFilterDOM)
    }

    // then add if not NULL
    const currFilter = dateFilter.getDateFilter()
    if (currFilter !== null) {
      this.dateFilterValue = currFilter
      let newFilter = document.createElement('button')
      newFilter.addClass('filter')
      newFilter.addClass('date-filter')
      newFilter.setAttribute('id', this.__idPrefix + 'date' + currFilter)
      newFilter.innerHTML = 'Year: ' + currFilter
      newFilter.onClick((ev) => {
        dateFilter.resetDateFilter()
      })
      this._e.querySelectorAll('.selected-filters')[0].appendChild(newFilter)
    }

    this.__dateFilterCallback()
  }

  // *********************
  // general filter processing:
  // *********************

  __generateFilter (filterItem) {
    let newFilter = document.createElement('button')
    newFilter.addClass('filter')
    newFilter.setAttribute('id', this.__idPrefix + filterItem.id)
    newFilter.innerHTML = filterItem.label
    newFilter.onClick((ev) => {
      this.removeFilter(filterItem)
    })
    return newFilter
  }

  addFilter (filterItem) {
    let found = false
    this.selectedFilters.forEach((e, i) => {
      if (e.id === filterItem.id) {
        found = true
      }
    })
    if (!found) {
      // add filter to the DOM
      const filterBtn = this.__generateFilter(filterItem, this.removeFilter)
      this._e.querySelectorAll('.selected-filters')[0].appendChild(filterBtn)

      // add filter to the list
      this.selectedFilters.push({label: filterItem.label, id: filterItem.id, filterItem: filterItem})

      this.__addFilterCallback()
    }
  }

  removeFilter (filterItem) {
    this.selectedFilters.forEach((e, i) => {
      if (e.id === filterItem.id) {
        // remove from the list
        this.selectedFilters.splice(i, 1)
        // remove from DOM
        const filterDOMElement = this._e.querySelectorAll('#' + this.__idPrefix + filterItem.id)[0]
        filterDOMElement.parentNode.removeChild(filterDOMElement)
        // do cb
        this.__removeFilterCallback(filterItem)
      }
    })
  }

  removeAllFilters () {
    this.__clearAllFiltersCallback()
  }

  // *********************
  // event count processing:
  // *********************

  updateCount (newCount) {
    this._e.querySelectorAll('span.count')[0].innerHTML = newCount
  }
} */
